module.exports = __webpack_public_path__ + "img/lightbulb-regular.c3203e4b.svg";